export enum EnterpriseTypes {
	proprietor = 'proprietor',
	partnership = 'partnership',
	plc = 'plc',
	ltd = 'ltd',
	cc = 'cc',
}
